export const sx = {
    '& th': {
        fontWeight: 700,
        '.lightTheme &:last-child': {
            borderRight: '1px solid transparent !important',
        },
        '.lightTheme &':{
            backgroundColor: '#fff',
            borderRight: '1px solid #5f5f5f1a !important',
        }
    }
}